import { makeStyles, useTheme } from '@material-ui/core/styles';
import React from 'react';
import MessengerCustomerChat from 'react-messenger-customer-chat';

const useStyles = makeStyles(theme => ({
  root: {
    position: 'fixed',
    right: 60,
    bottom: 60,
    zIndex: 100,
    minWidth: 60,
    minHeight: 60
  }
}));

const Chat = () => {
  const classes = useStyles();
  const theme = useTheme();

  const config = {
    pageId: '1628095894124934',
    appId: '1059039824185452',
    htmlRef: 'https://connect.facebook.net/en_US/sdk/xfbml.customerchat.js',
    themeColor: theme.palette.primary.main
  };

  return (
    <div className={classes.root}>
      {typeof window !== 'undefined' && <MessengerCustomerChat {...config} />}
    </div>
  );
};

export default Chat;
